import React, { Suspense, useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Divider } from "@mui/material";
import ConiditionColumn from "../layout/ConditionColumn";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
  getWorkspaceDataById,
  listenDocDataByIdX,
} from "../models/DataFunctions";
import { useNavigate } from "react-router-dom";
import ParametersNavBar from "../hexagone/ParametersNavBar";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { useSnackbar } from "notistack";

import Icon1 from "../icons/Icon";
import NavPortal from "../portal/NavPortal";
import LoginPartner from "../pages/LoginPartner";
import loginAs from "../api/loginAs";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import { useAppContext } from "./AppContext";

import { getOrRefreshFirebaseToken } from "./getFirebaseToken";

import sendErrorDiscord from "../api/sendErrorDiscord";

import SecondaryButton from "../buttons/SecondaryButton";
import NavBar from "../hexagone/NavBar";
import HeaderBar from "../hexagone/HeaderBar";
import startGleapSession from "../api/auth/startGleapSession";
import Gleap from "gleap";
import RoutesManager from "./RoutesManager";
import { isLight } from "../hexagone/VisibilityHelpers";

import { getOrgById } from "../models/OrgFunctions";
import { getUserById } from "../models/UserFunctions";
import { getAuthCentral } from "./FirebaseConfig";
import SmallSpinner from "../loading/SmallSpinner";
import { useNotificationNavigation } from "./FirebaseNotificationsNavigationHandler";
import HoverBar from "../hexagone/HoverBar";

const Entree = React.lazy(() => import("../pages/Entree"));
const Login = React.lazy(() => import("../pages/Login"));
const ProtectedRoute = React.lazy(() => import("../auth/ProtectedRoute"));
const Redirect = React.lazy(() => import("../pages/Redirect"));
const Setup = React.lazy(() => import("../pages/Setup"));
const InvoiceSign = React.lazy(() => import("../portal/InvoiceSign"));
const Signin = React.lazy(() => import("../pages/Signin"));
const NotFound = React.lazy(() => import("../pages/NotFound"));
const StripeSuccess = React.lazy(() => import("../pages/StripeSuccess"));

const x_pages = [
  "bordel",
  "home",
  "stats",
  "client",
  "partner",
  "master",
  "expert",
  "folder",
  "planning",
  "planning2",
  "user",
  "guest",
  "org",
  "logs",
  "applogs",
  "support-requests",
  "bookshelf",
  "action-admin",
  "setup-sessions",
  "transactions",
  "parameters",
  "devis",
  "facturation",
  "message",
  "rdv",
  "payments",
  "forum",
  "admin",
  "ai",
  "dashboard",
  "workspace",
  "payment",
  "emails-sync",
]; // Array of pages to show the NavBar

const portal_pages = ["folderportal", "rapport", "invoice-sign"]; // Array of pages to show the NavPortal

const getPageFromPath = (pathname) => {
  if (pathname === "/home") return "home";
  if (pathname === "/stats") return "stats";
  if (pathname === "/entree") return "entree";
  if (pathname === "/newclient") return "client";
  if (pathname === "/newpartner") return "partner";

  if (pathname === "/newexpert") return "expert";
  if (pathname === "/clients") return "client";
  if (pathname === "/partners") return "partner";

  if (pathname === "/login") return "login";
  if (pathname === "/login-partner") return "login-partner";
  if (pathname === "/stripe-success") return "stripe-success";
  if (pathname === "/experts") return "expert";
  if (pathname === "/folders") return "folder";
  if (pathname === "/newfolder") return "folder";
  if (pathname === "/parameters") return "parameters";
  if (pathname === "/organisation") return "parameters";
  if (pathname === "/account") return "parameters";
  if (pathname === "/facturation") return "parameters";
  if (pathname === "/mobileapp") return "parameters";
  if (pathname === "/rdvparams") return "parameters";

  if (pathname === "/stripe") return "parameters";
  if (pathname === "/bridge") return "parameters";
  if (pathname === "/cil") return "parameters";

  if (pathname === "/infiltrea") return "parameters";
  if (pathname === "/pennylane") return "parameters";
  if (pathname === "/google-calendar") return "parameters";
  if (pathname === "/agenda") return "parameters";

  if (pathname === "/rtb") return "parameters";
  if (pathname === "/xml") return "parameters";
  if (pathname === "/validation") return "parameters";
  if (pathname === "/devisparams") return "parameters";
  if (pathname === "/controlparams") return "parameters";
  if (pathname === "/gallery") return "parameters";
  if (pathname === "/widget") return "parameters";

  if (pathname === "/invitemanager") return "parameters";
  if (pathname === "/reminders") return "parameters";
  if (pathname === "/formparams") return "parameters";
  if (pathname === "/products") return "parameters";
  if (pathname === "/packs") return "parameters";
  if (pathname === "/email") return "parameters";
  if (pathname === "/extraction-ia") return "parameters";

  if (pathname === "/tags") return "parameters";
  if (pathname === "/ath") return "parameters";
  if (pathname === "/documents") return "parameters";
  if (pathname === "/bookshelfclient") return "bookshelf";
  if (pathname === "/bookshelf") return "parameters";

  if (pathname === "/athspe") return "parameters";
  if (pathname === "/masters") return "parameters";

  if (pathname === "/perso") return "parameters";
  if (pathname === "/notifications") return "parameters";
  if (pathname === "/forum") return "forum";
  if (pathname === "/ai") return "ai";
  if (pathname === "/dashboard") return "dashboard";
  if (pathname === "/setup-sessions") return "setup-sessions";
  if (/^\/setup-session\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "setup-sessions";
  }
  // Use a regular expression to match dynamic paths like /client/:id

  if (/^\/partner\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "partner";
  }
  if (/^\/payment\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "payment";
  }
  if (pathname === "/payments") return "payments";

  if (/^\/modifypartner\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "partner";
  }
  if (/^\/expert\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "expert";
  }
  if (/^\/modifyexpert\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "expert";
  }

  if (/^\/folder\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "folder";
  }
  if (/^\/folder-v2\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "folder";
  }
  if (/^\/folderportal\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "folderportal";
  }

  if (/^\/modifyfolder\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "folder";
  }
  if (/^\/modifypayment\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "payment";
  }
  if (/^\/rapport\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "rapport";
  }

  if (/^\/invoice-sign\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "invoice-sign";
  }

  if (pathname === "/invoice-sign") return "invoice-sign";

  if (pathname === "/planning") return "planning";
  if (pathname === "/planning-rdv") return "planning";
  if (pathname === "/planning2") return "planning2";
  if (pathname === "/planning-s") return "planning";

  if (pathname === "/messages") return "message";
  if (pathname === "/rdv") return "rdv";
  if (pathname === "/payments") return "payments";
  if (pathname === "/admin-payments") return "payments";

  if (pathname === "/orgs") return "org";
  if (pathname === "/users") return "user";
  if (pathname === "/guests") return "guest";

  if (/^\/org\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "org";
  }
  if (/^\/user\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "user";
  }
  if (pathname === "/logs") return "logs";
  if (pathname === "/applogs") return "applogs";
  if (pathname === "/support-requests") return "support-requests";
  if (pathname === "/action-admin") return "action-admin";

  if (pathname === "/transactions") return "transactions";
  if (pathname === "/invoices") return "devis";
  if (pathname === "/newinvoice") return "devis";
  if (pathname === "/newinvoicedraft") return "devis";
  if (pathname === "/newinvoicefromdraft") return "devis";

  if (pathname === "/newinvoiceclient") return "devis";
  if (/^\/invoice\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "devis";
  }
  if (/^\/newinvoicefromdraft\/[a-zA-Z0-9]+$/.test(pathname)) {
    return "devis";
  }
  if (pathname === "/newdemand") return "folder";
  if (pathname === "/newdemandpartner") return "folder";

  if (pathname === "/tempo-parameters") return "facturation";

  if (pathname.includes("workspace")) {
    // get after /workspace/id part
    let path = pathname.split("workspace/")[1];
    let path2 = path.split("/")[1];
    if (getPageFromPath("/" + path2) === "parameters") {
      return "parameters";
    }

    return "workspace";
  }

  if (pathname.includes("workspace")) return "workspace";
  if (pathname.includes("admin")) return "admin";

  // IMP PAGES
  if (/^\/imp\/[a-zA-Z0-9]+\/home$/.test(pathname)) {
    return "home";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/folders$/.test(pathname)) {
    return "folder";
  }
  if (/^\/imp-portal\/folderportal\/[^/]+$/.test(pathname)) {
    return "folderportal";
  }
  if (/^\/imp-portal\/rapport\/[^/]+$/.test(pathname)) {
    return "folderportal";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/invoices$/.test(pathname)) {
    return "devis";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/forum$/.test(pathname)) {
    return "forum";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/rdv$/.test(pathname)) {
    return "rdv";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/planning$/.test(pathname)) {
    return "planning";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/parameters$/.test(pathname)) {
    return "parameters";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/account$/.test(pathname)) {
    return "parameters";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/organisation$/.test(pathname)) {
    return "parameters";
  }
  if (/^\/imp\/[a-zA-Z0-9]+\/tags$/.test(pathname)) {
    return "parameters";
  }

  if (pathname === "/emails-sync") return "emails-sync";

  return ""; // Default value for unknown pages
};

// Array of pages to show the NavBar

const App = () => {
  const location = useLocation();
  //useNotificationNavigation();

  const navigate = useNavigate();
  const actualpage = getPageFromPath(location.pathname);

  let isinside = x_pages.includes(actualpage);
  const {
    appState,
    setAppState,
    filter,
    eventFilter,
    resetAppStateLogin,
    setFilter,
    refreshFolders,
    setEventFilter,
    fetchFolders,
    setOriginalAdmin,
    clearOriginalAdmin,
  } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const wsprefix = appState.dev
    ? "http://localhost:8081/"
    : "https://hexa-websockets-518651086100.europe-west9.run.app/";
  const saved_data = appState.saved_data;
  let isinsideportal = portal_pages.includes(actualpage);
  let isinparameters = actualpage === "parameters";
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const auth = getAuthCentral();
  const [loading_redirect, setLoadingRedirect] = useState(false);
  const { currentUser, loading } = useAuth();
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const [masterData, setMasterData] = useState(null);
  const [workspaceData, setWorkspaceData] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const handleSetMasterData = (data) => {
    if (data?.id === masterData?.id) {
      setMasterData(data);
    }
  };

  const handleSetOrgData = (data) => {
    if (data?.id === orgData?.id) {
      setOrgData(data);
    }
  };

  const handleSetUserData = (data) => {
    if (data?.id === userData?.id) {
      //  console.log("listen update user", data);
      setUserData(data);
    }
  };

  const handleSetWorkspaceData = (data) => {
    if (data?.id === workspaceData?.id) {
      setWorkspaceData(data);
    }
  };

  const handleSetWorkspacesData = (data) => {
    if (!data?.id) return;

    if (workspaces?.map((w) => w.id).includes(data?.id)) {
      const updatedWorkspaces = workspaces.map((w) =>
        w.id === data.id ? { ...w, ...data } : w
      );
      setWorkspaces(updatedWorkspaces);
    }
  };

  const handleRefreshOrg = async (orgData) => {
    // console.log("handleRefreshOrg", orgData);

    let workspace_id = workspaceId();
    //console.log("workspace_id", workspace_id);
    if (workspace_id && workspace_id != "myself") {
      if (
        //  filter?.workspace?.id !== workspaceId() &&
        workspaceId() &&
        workspaceId() != "myself"
      ) {
        const workspace = await getWorkspaceDataById(workspaceId());
        if (!workspace) {
          console.error("Workspace not found for id:", workspaceId());
          return;
        }
        setWorkspaceData(workspace);
        // console.log("workspace", workspace);

        const master = await getOrgById(workspace.master_id);
        setMasterData(master);

        setFilter({
          org_id: orgData.id,
          type: "partner",
          workspace: workspace,
          state: "current",
        });
        setEventFilter({
          org_id: orgData.id,
          type: "partner",
          workspace: workspace,
        });
      } else {
        // console.log("ilter?.workspace?.id === workspaceId() or not exists");
      }
    } else {
      // console.log("no workspace id or in myself mode");
      setFilter({
        org_id: orgData.id,
        type: "master",
        workspace: null,
        state: "current",
      });
      setEventFilter({
        org_id: orgData.id,
        type: "master",
        workspace: null,
      });
      setWorkspaceData(null);
    }
  };

  useEffect(() => {
    if (orgData) {
      handleRefreshOrg(orgData);
    }
  }, [workspaceId()]);

  const [errorMessage, setErrorMessage] = useState("");

  // We use `useState` to ensure the Connect instance is only initialized once

  const fetchClientSecret = async () => {
    if (!currentUser) return null;
    const token = await getOrRefreshFirebaseToken();
    const response = await fetch(
      prefix + "stripeconnect/create-account-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );

    if (!response.ok) {
      const { error } = await response.json();
      console.error("An error occurred: ", error);
      setErrorMessage(error);
      return null; // Return null on error
    }

    const { client_secret: clientSecret } = await response.json();
    return clientSecret;
  };

  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);

  const initializeGleapSession = async () => {
    Gleap.initialize("XtqBJCLBhmgLbHJj3wqjOvchS3TEMzIb");
    Gleap.setLanguage("fr");
    if (!auth?.currentUser) {
      console.warn("Gleap not initialized, no user logged in");
      return;
    }
    const token = await getOrRefreshFirebaseToken();
    let data = await startGleapSession(token, prefix);
    if (data) {
      Gleap.identify(
        data.user_id,
        {
          name: data.name,
          email: data.email,

          phone: data.phone,
          value: data.value,
          plan: data.plan,
          companyId: data.companyId,
          companyName: data.companyName,
          // Passing the createdAt property allows you to set the correct createdAt date. (optional)
          createdAt: data.createdAt ? new Date(data.createdAt * 1000) : null,
          customData: {
            type: data.customData?.type || "?",
            master_id: data.customData?.master_id || "?",
            master_name: data.customData?.master_name || "?",
            master_email: data.customData?.master_email || "?",
          },
        },

        data.gleap_user_hash
      );
    }

    // 🔧 Wait for Gleap to inject itself, then fix pointer-events
    setTimeout(() => {
      const gleapIframe = document.querySelector('iframe[src*="gleap"]');
      if (gleapIframe) {
        gleapIframe.style.pointerEvents = "auto";
        gleapIframe.style.zIndex = "999999";
      }

      const gleapDivs = document.querySelectorAll('div[class*="gleap"]');
      gleapDivs.forEach((el) => {
        el.style.pointerEvents = "auto";
        el.style.zIndex = "999999";
      });
    }, 1000); // 1 second is usually safe, tweak if needed
  };

  // const initializeStripeConnect = async (orgData) => {
  //   try {
  //     const clientSecret = await fetchClientSecret();
  //     if (!clientSecret) return; // Stop if client secret is not retrieved

  //     const stripeInstance = loadConnectAndInitialize({
  //       publishableKey:
  //         "pk_live_51PLVCpP0DpBSzCykxNgbYgQCAMyAnptFsuyVyCE5euDqLNTd1sdaCABHordqhGVsOLvFYM5dHevmF8dwoSqAQHwe00VucEBoBB",
  //       fetchClientSecret, // ✅ Pass the function, not the result!
  //       stripeAccount: orgData.stripe_connect?.account_id,
  //       settings: {
  //         analytics: false, // Disable analytics tracking
  //       },
  //     });

  //     setStripeConnectInstance(stripeInstance);
  //   } catch (error) {
  //     console.error("Error initializing Stripe Connect:", error);
  //   }
  // };

  const handleFetchData = async (currentUser, override_id) => {
    // console.log("handleFetchData");
    // console.log("override_id", override_id);
    // console.log(" currentUser", currentUser);

    Gleap.close();
    if (currentUser) {
      try {
        const user = await getUserById(override_id || currentUser.uid);
        // console.log("user", user);
        if (!user) {
          console.error("user not found ");
          if (isinside) {
            navigateWorkspace("/login", orgData);
          }

          return;
        } else if (isinsideportal && !isImpPortal()) {
          let actualpage = location.pathname;
          //await handleLogout(actualpage);
          console.warn("user exists within portal, logging out");
          console.warn("loggin out CANCELED");
          return;
        }

        if (currentUser) {
          initializeGleapSession();
        }

        const org = await getOrgById(user.org_id); // Récupère l'organisation par référence
        //console.log("org", org);
        if (!org) {
          navigateWorkspace("/setup", orgData);
          console.error("org not found");
          return;
        }
        const workspaces = await getArrayDocDataByID(
          "workspace",
          org.workspaces_id || []
        );
        setWorkspaces(workspaces);

        if (workspaceId() && workspaceId() != "myself") {
          const workspace = await getWorkspaceDataById(workspaceId());
          if (!workspace) {
            console.error("workspace not found");
            navigateWorkspace("/login");
            return;
          }
          if (workspace.partner_id !== org.id) {
            // i should not be in this workspace
            if (isLight(org)) {
              // redirect to first workspace
              console.warn(
                "not partner of workspace, redirecting to first workspace"
              );
              navigateWorkspace("/home", orgData, org.workspaces_id[0]);
            } else {
              // redirect my own workspace
              console.warn(
                "not partner of workspace, redirecting to my workspace"
              );
              navigateWorkspace("/home", orgData, "myself");
            }
            setOrgData(org);

            setUserData(user);
            setWorkspaceData(null);
            return;
          }

          const master = await getOrgById(workspace.master_id);
          setUpdateListeners({
            user_id: user.id,
            org_id: org.id,
            master_id: master.id,
            workspace_id: workspace.id,
            workspaces_id: workspaces.map((w) => w.id),
          });
          setWorkspaceData(workspace);
          setMasterData(master);

          setFilter({
            org_id: org.id,
            type: "partner",
            workspace: workspace,
            state: "current",
          });
          setEventFilter({
            org_id: org.id,
            type: "client",
            workspace: workspace,
          });
        } else if (isLight(org)) {
          //console.log("no workspace id, using first workspace");
          if (!org.workspaces_id || org.workspaces_id.length === 0) {
            console.error("no workspaces found for org", org);
            logoutUser();
            return;
          }
          const workspace = await getDocDataById(
            "workspace",
            org.workspaces_id[0]
          );
          if (!workspace) {
            console.error("workspace not found for org", org);
            logoutUser();
            return;
          }
          const master = await getOrgById(workspace.master_id);

          setMasterData(master);

          setWorkspaceData(workspace);

          if (workspaceId() === "myself") {
            navigateWorkspace("/home", orgData, workspace.id);
          }

          setUpdateListeners({
            user_id: user.id,
            org_id: org.id,
            master_id: workspace.master_id,
            workspace_id: workspace.id,
            workspaces_id: workspaces.map((w) => w.id),
          });

          setFilter({
            org_id: org.id,
            type: "partner",
            workspace: workspace,
            state: "current",
          });
          setEventFilter({
            org_id: org.id,
            type: "client",
            workspace: workspace,
          });
        } else {
          // console.log("no workspace id or in myself mode");
          setWorkspaceData(null);
          setMasterData(org);

          setFilter({
            org_id: org.id,
            type: "master",
            workspace: null,
            state: "current",
          });
          setEventFilter({
            org_id: org.id,
            type: "master",
            workspace: null,
          });
        }

        setOrgData(org);

        setUserData(user);

        //console.log("user", user);
        setUpdateListeners({
          user_id: user.id,
          org_id: org.id,
          master_id: org.id,
          workspace_id: workspaceId(),
          workspaces_id: workspaces.map((w) => w.id),
        });
        if (
          false &&
          org.stripe_connect?.connected &&
          org.stripe_connect?.account_id
        ) {
          //  initializeStripeConnect(org);
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );

        // Envoyer l'erreur à Discord avec le contexte
        const errorContext = {
          uid: currentUser?.uid,
          email: currentUser?.email,
          error: error.message,
          stack: error.stack,
        };
        await sendErrorDiscord(
          `Erreur handleFetchData: ${JSON.stringify(errorContext, null, 2)}`,
          prefix,
          { uid: currentUser?.uid, email: currentUser?.email }
        );

        // Rediriger vers login pour éviter la page blanche
        handleClickVariant(
          "Erreur lors du chargement de vos données. Veuillez réessayer.",
          "error"
        );
        setTimeout(() => {
          navigateWorkspace("/login");
        }, 2000);
      }
    }
  };
  useEffect(() => {
    if (!currentUser && !loading) {
      if (isinside) {
        navigate("/login");
      } else {
      }
    }
    handleFetchData(currentUser, overrideId());
  }, [currentUser, loading, overrideId()]); // Add overrideId() to the dependency array

  const unsubscribeUserData = useRef(null);
  const unsubscribeOrgData = useRef(null);
  const unsubscribeMasterData = useRef(null);
  const unsubscribeWorkspaceData = useRef(null);
  const unsubscribeWorkspaces = useRef(null);
  const [updateListeners, setUpdateListeners] = useState({});
  const reconnectAttempts = useRef(0);
  const ws = useRef(null);
  const currentUserDataRef = useRef(userData);
  useEffect(() => {
    currentUserDataRef.current = userData;
  }, [userData]);

  const maintenance_websocket_ref = useRef();

  useEffect(() => {
    maintenance_websocket_ref.current = false;
  }, []);

  const handleSetMaintenanceWebsoket = async (value) => {
    maintenance_websocket_ref.current = value.websocket_active;
  };
  // start with current = false
  const unsubscribeMaintenanceWebsocket = useRef(null);

  useEffect(() => {
    listenDocDataByIdX(
      "maintenance",
      "main",
      handleSetMaintenanceWebsoket,
      unsubscribeMaintenanceWebsocket
    );
    return () => {
      if (unsubscribeMaintenanceWebsocket.current) {
        unsubscribeMaintenanceWebsocket.current();
      }
    };
  }, []);

  const tryReconnect = useRef(false);
  const reconnectTimeout = useRef(null);

  useEffect(() => {
    if (!userData || maintenance_websocket_ref.current === false) {
      return;
    }
    if (appState.dev) {
      return;
    }

    const connect = () => {
      if (appState.dev) {
        return;
      }
      if (ws.current) {
        console.warn("🛑 WebSocket already exists, skipping new connection.");
        return;
      }

      const user = currentUserDataRef.current;
      if (!user || !user.id) {
        console.warn("❌ No user data available, cannot connect WebSocket.");
        return;
      }
      const url = `${wsprefix}ws/online/${user?.id}`;
      // console.log("🔌 Connecting WebSocket to", url);

      const socket = new WebSocket(url);
      ws.current = socket;

      socket.onopen = () => {
        //  console.log("✅ WebSocket connected user", user.id);
      };

      socket.onclose = () => {
        //  console.log("❌ WebSocket disconnected");

        ws.current = null; // Clean up so we know it’s gone

        retryConnection();
      };

      socket.onerror = (e) => {
        console.error("❌ WebSocket error", e);
        socket.close(); // Trigger onclose
      };
    };

    const retryConnection = () => {
      const delay = Math.min(60000, 1000 * 2 ** reconnectAttempts.current); // Cap at 60s
      //  console.log(`⏳ Reconnecting in ${delay / 1000}s...`);
      reconnectAttempts.current += 1;

      reconnectTimeout.current = setTimeout(() => {
        connect();
      }, delay);
    };

    connect();

    return () => {
      //  console.log("❌ Cleaning up WebSocket");
      if (ws.current) {
        ws.current.close();
        ws.current = null;
      }
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }
    };
  }, [userData?.id, maintenance_websocket_ref]);

  useEffect(() => {
    // updateListeners is an array of functions that will be called when the orgData is updated
    if (updateListeners.user_id) {
      listenDocDataByIdX(
        "user",
        updateListeners.user_id,
        handleSetUserData,
        unsubscribeUserData
      );
    }

    if (updateListeners.workspace_id) {
      listenDocDataByIdX(
        "workspace",
        updateListeners.workspace_id,
        handleSetWorkspaceData,
        unsubscribeWorkspaceData
      );
    }
    if (updateListeners.workspaces_id) {
      updateListeners.workspaces_id.forEach((workspace_id) => {
        listenDocDataByIdX(
          "workspace",
          workspace_id,
          handleSetWorkspacesData,
          unsubscribeWorkspaces
        );
      });
    }

    if (updateListeners.org_id) {
      listenDocDataByIdX(
        "org",
        updateListeners.org_id,
        handleSetOrgData,
        unsubscribeOrgData
      );
    }
    if (updateListeners.master_id) {
      listenDocDataByIdX(
        "org",
        updateListeners.master_id,
        handleSetMasterData,
        unsubscribeMasterData
      );
    }

    return () => {
      if (unsubscribeUserData.current) {
        unsubscribeUserData.current();
      }
      if (unsubscribeOrgData.current) {
        unsubscribeOrgData.current();
      }
      if (unsubscribeMasterData.current) {
        unsubscribeMasterData.current();
      }
      if (unsubscribeWorkspaceData.current) {
        unsubscribeWorkspaceData.current();
      }
      if (unsubscribeWorkspaces.current) {
        unsubscribeWorkspaces.current();
      }
    };
  }, [updateListeners]);

  const handleLogout = async (goback_url) => {
    try {
      console.warn("handleLogout");
      Gleap.clearIdentity();
      Gleap.close();

      resetAppStateLogin();

      // Check if we have original admin data to restore
      const originalAdmin = appState.original_admin;

      if (originalAdmin) {
        console.warn("Restoring original admin account");
        // Sign in back as the original admin
        const token = await loginAs(
          originalAdmin.uid,
          originalAdmin.token,
          prefix
        );
        await signInWithCustomToken(auth, token);
        clearOriginalAdmin();
        navigateWorkspace("/home");
      } else {
        // Fallback to localStorage (for backward compatibility)
        const adminToken = localStorage.getItem("lastToken");

        if (adminToken) {
          const adminId = localStorage.getItem("lastId");
          localStorage.removeItem("lastId");
          localStorage.removeItem("lastToken");
          const token = await loginAs(adminId, adminToken, prefix);
          await signInWithCustomToken(auth, token);
          navigateWorkspace("/home");
        } else {
          await logoutUser();
          if (goback_url) {
            navigateWorkspace(goback_url);
          } else {
            navigateWorkspace("/login"); // Navigate to "entree" after logout
          }
        }
      }
      setUpdateListeners({});
      setUserData(null);
      setOrgData(null);
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  const handleLoginAs = async (id) => {
    console.warn("handleLoginAs", id);
    Gleap.clearIdentity();
    setUserData(null);
    setOrgData(null);
    setUpdateListeners({});
    const auth = getAuthCentral();

    try {
      if (!id) {
        console.error("Invalid user id");
        return;
      }

      // Save original admin data if not already saved
      if (!appState.original_admin && currentUser) {
        const originalAdminData = await getUserById(currentUser.uid);
        const originalToken = await currentUser.getIdToken();
        setOriginalAdmin({
          token: originalToken,
          userData: originalAdminData,
          uid: currentUser.uid,
        });
      }

      // Sign out the current user before switching
      const token = await currentUser.getIdToken(); // Fetch token from Firebase

      const switch_token = await loginAs(id, token, prefix, currentUser.uid);

      // Sign in with the custom token
      await signInWithCustomToken(auth, switch_token);

      // Wait until the currentUser is available
      let refreshedUser = null;
      for (let i = 0; i < 10; i++) {
        refreshedUser = auth.currentUser;
        if (refreshedUser) break;
        await new Promise((resolve) => setTimeout(resolve, 200)); // wait 200ms
      }

      if (!refreshedUser) {
        throw new Error("Failed to retrieve the current user after login.");
      }
      // Fetch user data based on currentUser uid
      const userData = await getUserById(refreshedUser.uid);
      //console.log("userData", userData.ref);
      if (!userData || !userData.org_id) {
        throw new Error("Invalid user data or missing org_id.");
      }

      // Fetch org data
      const orgData = await getOrgById(userData.org_id);
      const workspaces = await getArrayDocDataByID(
        "workspace",
        orgData.workspaces_id
      );
      let new_workspace_id =
        workspaces.length === 0 || orgData.facturation?.plans.includes("basic")
          ? "myself"
          : workspaces[0].id;
      let path = "/home";

      //navigateWorkspace("abort_override"); // Navigate to a protected route after successful login
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  function overrideId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("imp");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  function workspaceId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("workspace");
    if (workspaceIndex !== -1) {
      let workspaceId = path[workspaceIndex + 1];

      return workspaceId;
    } else {
      return null;
    }
  }

  const navigateWorkspace = (
    path,
    newOrg = null,
    workspace_id = null,
    redirect_path = null
  ) => {
    if (path === -1) {
      navigate(-1);
      return;
    }
    let org = newOrg || orgData;
    // console.log("navigateWorkspace", path);
    if (path === "abort_override") {
      let redirect_to_a_folder = redirect_path?.includes("folder/");

      let redirect_to_folder_from_portal =
        redirect_path?.includes("folderportal/");
      if (redirect_to_a_folder && redirect_path) {
        console.warn("redirect_to_home_first");
        navigate("/workspace/myself/home");

        let folder_id = redirect_path.split("folder/")[1];
        let cleaned_folder_id = folder_id.split("/")[0];

        setLoadingRedirect(true);
        // redirect 2 seconds laterss
        setTimeout(() => {
          navigate("/workspace/myself/folder/" + cleaned_folder_id);
          setLoadingRedirect(false);
        }, 1000);
      } else if (redirect_to_folder_from_portal) {
        let folder_id = redirect_path.split("folderportal/")[1];
        let cleaned_folder_id = folder_id.split("/")[0];
        console.warn("redirect_to_a_folder", redirect_path);

        navigate("/workspace/myself/folder/" + cleaned_folder_id);
      } else {
        navigate("/workspace/myself/home");
      }
      return;
    }
    if (["/login", "/login-partner", "/signin", "/entree"].includes(path)) {
      navigate(path);
      return;
    }
    if (path?.includes("/folders")) {
      fetchFolders();
    }
    if (path?.includes("/imp/") || path?.includes("/imp-portal/")) {
      navigate(path);
    } else {
      if ((workspaceId() || workspace_id) && workspace_id != "myself") {
        if (overrideId()) {
          navigate(
            "/imp/" +
              overrideId() +
              "/workspace/" +
              (workspace_id || workspaceId()) +
              path
          );
        } else {
          navigate("/workspace/" + (workspace_id || workspaceId()) + path);
        }
      } else {
        if (org && org.workspaces_id?.length > 0 && isLight(org)) {
          if (overrideId()) {
            navigate(
              "/imp/" +
                overrideId() +
                "/workspace/" +
                (workspace_id || workspaceId() || org.workspaces_id[0]) +
                path
            );
          } else {
            navigate(
              "/workspace/" +
                (workspace_id || workspaceId() || org.workspaces_id[0]) +
                path
            );
          }
        } else if (isImpPortal()) {
          path = path.replace("/imp-portal", "/");
          path = "/imp-portal" + path;
          navigate(path);
        } else {
          navigate(path);
        }
      }
    }
  };

  function isOverriding() {
    return location.pathname?.includes("/imp/");
  }

  function isImpPortal() {
    return location.pathname?.includes("/imp-portal/");
  }

  function overrideId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("imp");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  function workspaceId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("workspace");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  const [client_notify, setClientNotify] = useState(true);

  const handleSetMaintenanceCaution = async (value) => {
    let current_page = getPageFromPath(location.pathname);
    if (isinside && value.active && current_page !== "login") {
      if (currentUser) {
        let user = await getUserById(currentUser.uid);
        // console.log("user.email", user.email);

        //  console.log("user.maintenance_proof", user.maintenance_proof);
        if (user && user.maintenance_proof) {
        } else {
          console.warn("maintenance active, redirecting to entree");
          navigateWorkspace("/entree");
        }
      }
    }
  };
  const [maintenance_chill, setMaintenanceChill] = useState(null);
  const [maintenance_status, setMaintenanceStatus] = useState(null);

  const handleSetMaintenanceChill = async (value) => {
    setMaintenanceChill(value);
  };
  const handleSetMaintenanceStatus = async (value) => {
    setMaintenanceStatus(value);
  };

  const [version, setVersion] = useState(null);
  const [messageNewVersion, setMessageNewVersion] = useState(false);
  const [updateNotes, setUpdateNotes] = useState(null);
  const [showUpdateNotes, setShowUpdateNotes] = useState(false);

  const checkUpdateNotes = async () => {
    try {
      const promo = await getDocDataById("maintenance", "promotion");
      const updates = promo?.last_updates;
      if (!updates || updates.length === 0) return;
      // Sort by date descending
      const sorted = [...updates].sort((a, b) => (b.date?.seconds || 0) - (a.date?.seconds || 0));
      // Hash based on count + latest message to detect changes
      const content = sorted.map((u) => u.message || "").join("||");
      let hash = 0;
      for (let i = 0; i < content.length; i++) {
        hash = ((hash << 5) - hash + content.charCodeAt(i)) | 0;
      }
      const key = "hexagone_seen_updates";
      const seen = localStorage.getItem(key);
      if (seen !== String(hash)) {
        // Show only recent updates (last 5 days)
        const fiveDaysAgo = Date.now() / 1000 - 5 * 86400;
        const recent = sorted.filter((u) => (u.date?.seconds || 0) > fiveDaysAgo);
        if (recent.length > 0) {
          setUpdateNotes({ updates: recent, hash: String(hash) });
          setShowUpdateNotes(true);
        } else {
          // No recent updates, just save the hash so it doesn't check again
          localStorage.setItem(key, String(hash));
        }
      }
    } catch (err) {
      console.error("Error checking update notes:", err);
    }
  };

  const dismissUpdateNotes = () => {
    if (updateNotes?.hash) {
      localStorage.setItem("hexagone_seen_updates", updateNotes.hash);
    }
    setShowUpdateNotes(false);
  };
  useEffect(() => {
    fetch("/version.txt")
      .then((response) => response.text())
      .then((text) => setVersion(text))
      .catch((error) => console.error("Error fetching version:", error));
  }, []);

  const [loadingVersion, setLoadingVersion] = useState(false);

  const isProd = !window.location.href.includes("localhost");

  const handleSetVersion = (value) => {
    const LOCAL_VERSION = version || 5;
    if (LOCAL_VERSION !== value.react_version.toString()) {
      // value.react_version is a number
    } else {
    }
    //console.log("LOCAL_VERSION", LOCAL_VERSION);
    // console.log(
    //   "value.react_version.toString()",
    //   value.react_version.toString()
    // );

    if (!isProd) {
      return;
    }

    if (isNaN(value.react_version)) {
      // should not happen
      sendErrorDiscord("VERSION IS NOT A NUMBER", prefix);
      return;
    }
    if (value.react_version > LOCAL_VERSION) {
      handleClickVariant("Nouvelle version disponible", "success");
      setMessageNewVersion(true);
      setLoadingVersion(false);
    }
  };

  const unsubscribeMaintenance = useRef(null);
  const unsubscribeMaintenanceChill = useRef(null);
  const unsubscribeMaintenanceStatus = useRef(null);

  const unsubscribeVersion = useRef(null);
  const handleInitiate = async (version) => {
    if (version) {
      let version2 = await getDocDataById("maintenance", "version");
      handleSetVersion(version2);
      // console.log("version2", version2);
    }
  };

  useEffect(() => {
    handleInitiate(version);

    listenDocDataByIdX(
      "maintenance",
      "maintenance",
      handleSetMaintenanceCaution,
      unsubscribeMaintenance
    );

    listenDocDataByIdX(
      "maintenance",
      "feXLghrFEHIXxEroBrSl",
      handleSetMaintenanceChill,
      unsubscribeMaintenanceChill
    );

    listenDocDataByIdX(
      "maintenance",
      "status",
      handleSetMaintenanceStatus,
      unsubscribeMaintenanceStatus
    );

    listenDocDataByIdX(
      "maintenance",
      "main",
      handleSetMaintenanceWebsoket,
      unsubscribeMaintenanceWebsocket
    );

    listenDocDataByIdX(
      "maintenance",
      "version",
      handleSetVersion,
      unsubscribeVersion
    );

    if (currentUser) {
      checkUpdateNotes();
    }

    return () => {
      if (unsubscribeMaintenance.current) {
        unsubscribeMaintenance.current();
      }
      if (unsubscribeMaintenanceChill.current) {
        unsubscribeMaintenanceChill.current();
      }
      if (unsubscribeMaintenanceStatus.current) {
        unsubscribeMaintenanceStatus.current();
      }
      if (unsubscribeMaintenanceWebsocket.current) {
        unsubscribeMaintenanceWebsocket.current();
      }
      if (unsubscribeVersion.current) {
        unsubscribeVersion.current();
      }
    };
  }, [version, currentUser]);

  return (
    <div
      className={`bg-transparent w-full h-screen  flex flex-col pointer-events-auto`}
    >
      {isOverriding() && (
        <div className=" w-screen pointer-events-auto bg-red-500 text-h1 items-center  shadow-md mb-2 font-bold text-white px-3 py-1 flex flex-row justify-between">
          Vous êtes sur le compte de votre partenaire
          <SecondaryButton
            onClick={() => {
              let redirect_path = location.pathname;
              navigateWorkspace("abort_override", null, null, redirect_path);
            }}
          >
            Retourner sur mon compte
          </SecondaryButton>
        </div>
      )}
      {isImpPortal() && (
        <div className=" w-screen pointer-events-auto bg-red-500 text-h1 font-semibold text-white px-3 py-3 flex flex-row justify-between">
          Vous êtes sur la vue du particulier
          <SecondaryButton
            onClick={() => {
              let redirect_path = location.pathname;
              navigateWorkspace("abort_override", null, null, redirect_path);
            }}
          >
            Retourner sur mon compte
          </SecondaryButton>
        </div>
      )}

      <div
        className={`
        ${
          location.pathname.includes("/planning")
            ? "bg-white"
            : location.pathname.includes("iframe")
              ? "bg-transparent"
              : "bg-white"
        }
         w-full h-full  flex sm:flex-row flex-col `}
      >
        <div
          id="MyDiv"
          className="flex h-full w-full items-stretch   flex-grow sm:flex-row  bg-transparent"
        >
          {loading_redirect && (
            <div className="fixed w-screen h-screen left-0 bg-white z-50 flex flex-col items-center justify-center">
              <div className="flex flex-row gap-10 items-center">
                <div className="">
                  <SmallSpinner />
                </div>
              </div>
            </div>
          )}

          {messageNewVersion && isProd && (
            <div
              onClick={() => {
                window.location.reload();
              }}
              className="fixed hover:-translate-y-1     hover:scale-105  transition-all duration-300 pointer-events-auto flex items-center justify-center bottom-10 min-w-fit left-1/2 -translate-x-1/2 z-30 flex-col gap-1 text-white h-fit w-fit  shadow-lg rounded-xl cursor-pointer"
            >
              <div className="px-8 py-4  bg-black rounded-xl z-10 flex flex-col gap-1">
                <div className="flex flex-row gap-10 items-center">
                  <div className="flex flex-col gap-2 ">
                    <div className="font-semibold">
                      Une nouvelle version est disponible sur le site.
                    </div>{" "}
                    <div className="">
                      Veuillez cliquez ici pour passer à la nouvelle version.
                    </div>
                  </div>{" "}
                  <div className="">
                    <Icon1 fill="white" icon_name="hexagone2" size={30}></Icon1>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showUpdateNotes && updateNotes?.updates?.length > 0 && (
            <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-auto">
              <div
                className="absolute inset-0 bg-black/40"
                onClick={dismissUpdateNotes}
              />
              <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 max-h-[80vh] flex flex-col">
                <div className="flex flex-row items-center justify-between px-6 pt-5 pb-3 border-b border-gray-100">
                  <div className="font-semibold text-lg text-black">
                    Mises à jour récentes
                  </div>
                  <div
                    className="cursor-pointer text-gray-400 hover:text-black text-xl leading-none px-1"
                    onClick={dismissUpdateNotes}
                  >
                    ✕
                  </div>
                </div>
                <div className="px-6 py-4 overflow-y-auto flex flex-col gap-3">
                  {updateNotes.updates.map((update, idx) => (
                    <div key={idx} className="flex flex-col gap-1">
                      <div className="text-xs text-gray-400">
                        {update.date?.seconds
                          ? new Date(update.date.seconds * 1000).toLocaleDateString("fr-FR")
                          : ""}
                      </div>
                      <div className="text-sm text-gray-700 whitespace-pre-wrap">{update.message}</div>
                    </div>
                  ))}
                </div>
                <div className="px-6 pb-5 pt-2 flex justify-end">
                  <div
                    className="bg-black text-white px-5 py-2 rounded-lg cursor-pointer hover:bg-gray-800 transition-colors text-sm font-medium"
                    onClick={dismissUpdateNotes}
                  >
                    Compris
                  </div>
                </div>
              </div>
            </div>
          )}
          {isinside && (
            <div
              className={` flex-col flex min-w-fit h-full ${overrideId() ? "max-h-[95vh]" : ""} overflow-auto bg-transparent z-10 `}
            >
              <NavBar
                actualpage={actualpage}
                local_version={version}
                orgData={orgData}
                masterData={masterData}
                userData={userData}
                override_id={overrideId()}
                navigateWorkspace={navigateWorkspace}
                handleLogout={handleLogout}
                handleLoginAs={handleLoginAs}
                workspaceData={workspaceData}
                workspaces={workspaces}
              />
            </div>
          )}

          {isinside && (
            <div
              className={` flex-col flex min-w-fit h-full ${overrideId() ? "max-h-[95vh]" : ""} overflow-auto bg-transparent z-60 `}
            >
              <HoverBar
                actualpage={actualpage}
                local_version={version}
                orgData={orgData}
                masterData={masterData}
                userData={userData}
                override_id={overrideId()}
                navigateWorkspace={navigateWorkspace}
                handleLogout={handleLogout}
                handleLoginAs={handleLoginAs}
                workspaceData={workspaceData}
                workspaces={workspaces}
              />
            </div>
          )}

          {isinside && isinparameters && (
            <ParametersNavBar
              actualpage={actualpage}
              override_id={overrideId()}
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
              workspaceData={workspaceData}
            />
          )}

          {isinsideportal && (
            <div
              className={` flex-col hidden sm:flex min-w-fit h-full ${isImpPortal() ? "max-h-[95vh]" : ""} overflow-auto bg-transparent `}
            >
              <NavPortal
                orgData={orgData}
                actualpage={actualpage}
                navigateWorkspace={navigateWorkspace}
                handleLogout={handleLogout}
              />
            </div>
          )}

          <div className="flex flex-col w-full h-full bg-transparent ">
            {isinside && (
              <HeaderBar
                userData={userData}
                orgData={orgData}
                navigateWorkspace={navigateWorkspace}
                override_id={overrideId()}
                maintenance_chill={maintenance_chill}
                maintenance_status={maintenance_status}
              />
            )}

            <Suspense fallback={<div></div>}>
              <Routes>
                <Route
                  path="*"
                  element={
                    <RoutesManager
                      userData={userData}
                      handleLogout={handleLogout}
                      masterData={masterData}
                      navigateWorkspace={navigateWorkspace}
                      orgData={orgData}
                      workspaceData={workspaceData}
                      refreshFolders={refreshFolders}
                      handleLoginAs={handleLoginAs}
                      stripeConnectInstance={stripeConnectInstance}
                    />
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default App;
